import React from 'react';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { formatCurrency } from 'utils';
import { AttachMoney, Inventory, TrendingUp } from '@mui/icons-material';

interface Props {
  totalAftermarketProfit: number;
  totalFIProfit: number;
  productsSoldCount: number;
}

export const FinanceSummaryCards = ({ totalAftermarketProfit, totalFIProfit, productsSoldCount }: Props) => {
  const summaryItems = [
    {
      label: 'Total Aftermarket Profit',
      value: formatCurrency(totalAftermarketProfit, true),
      icon: <TrendingUp color="primary" fontSize="large" />,
    },
    {
      label: 'Total F&I Profit',
      value: formatCurrency(totalFIProfit, true),
      icon: <AttachMoney color="primary" fontSize="large" />,
    },
    {
      label: 'Products Sold Count',
      value: productsSoldCount.toString(),
      icon: <Inventory color="primary" fontSize="large" />,
    },
  ];

  return (
    <Box sx={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem' }}>
      {summaryItems.map(({ label, value, icon }) => (
        <Card key={label} sx={{ flex: 1, minWidth: 0 }}>
          <CardContent>
            <Stack direction="row" spacing={2} alignItems="center">
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{icon}</Box>
              <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="body2" color="textSecondary" noWrap>
                  {label}
                </Typography>
                <Typography variant="h6" component="div" noWrap>
                  {value}
                </Typography>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};
